import { Component, OnInit } from "@angular/core";
import { Observable } from "rxjs/Observable";

import { TAAConstants } from "../../../../views/constants/taa-constants";
import { LoggerService } from "../../../../views/services/audit-logger.service";
import { CommonService } from "../../../../views/services/common.service";
import { DocumentService } from "../../../../views/services/document.service";
import { HeaderService } from "../../../../views/services/header.service";
import { PersonService } from "../../../../views/services/person.service";
import { RequestSubmitService } from "../../../../views/services/requestsubmit.service";
import { DocTypeService } from "../../accmgr/services/docType.service";
import { PaperStepperComponent } from "../process-paper-request/stepper/paper-stepper.component";
import { User } from "../../../../views/services/user.model";

@Component({
  selector: "app-accsupportdocumentation",
  templateUrl: "./accsupportdocumentation.component.html",
  styleUrls: ["./accsupportdocumentation.component.css"]
})
export class AccSupportDocumentationComponent implements OnInit {
  public successMessage: string;
  public errorMessage: string;
  public personName: string;
  public personId: string;
  public requetId: string;
  public taaPin: string;
  public noOfErrors: number;
  public currentRecord: any;
  public documents: any = [];
  public supportedFileSize: any;
  public supportedFileSizeMB: any;
  public supportedFileTypes: string;
  public supportedFileLength: string;
  public fetchGuidelinesLink: string;
  public errorMessageFlag: boolean;
  public sameDocErrFlag: boolean;
  public emptyDocErrFlag: boolean;
  public deletedDocFlag: boolean;
  public fileExists: boolean;
  public statusCode: any;
  public showContinue = false;
  public submitStatusCd: any;
  public apiCount: number = 0;
  public isLoading: boolean = false;
  public docReconsideration: string;
  public userProfile: User;
  public: number;
  public auditStatusText: string = "";
  public auditLogCategory: string = "";
  public clickOnce: boolean;
  public userDetails: any;
  public docTypes: any;
  public fileNm: any;
  public dropDownSelection: any;
  recordCount = '0';

  constructor(
    private _loggerService: LoggerService,
    private headerService: HeaderService,
    private documentService: DocumentService,
    private personService: PersonService,
    public taaConstants: TAAConstants,
    public commonService: CommonService,
    public stepper: PaperStepperComponent,
    public requestSubmitService: RequestSubmitService,
    private internalDocTypeService: DocTypeService
  ) { }

  ngOnInit() {
    this.buildForm();
    this.clickOnce = false;
    sessionStorage.setItem("accomSubmitted", "");
    this.isLoading = true;
    this.currentRecord = this.stepper.getPreviousRecordDetails();
    if (sessionStorage.getItem("currentStudent")) {
      const studentDetails: any = JSON.parse(
        sessionStorage.getItem("currentStudent")
      );
      this.currentRecord = studentDetails;
      this.personId = this.currentRecord.personId;
      this.requetId = this.currentRecord.requestId;
    } else {
      this.currentRecord = this.stepper.getPreviousRecordDetails();
      this.personId = this.currentRecord.personId;
      this.requetId = this.currentRecord.requestId;
    }
    const systemProperties = this.headerService.getSystemProperties();
    this.supportedFileSize =
      systemProperties["DOCUMENTATION_MAX_UPLOAD_SIZE_HEADER"];
    this.supportedFileTypes =
      systemProperties["DOCUMENTATION_SUPPORTED_FILE_TYPES"];
    this.supportedFileLength =
      systemProperties["DOCUMENTATION_MAX_UPLOAD_FILE_NM_LENGTH_HEADER"];
    this.fetchGuidelinesLink =
      systemProperties["SYSTEM_KEY_ACCOMM_GUIDELINES_LINK"];
    this.supportedFileSizeMB = this.formatFileSize(this.supportedFileSize, 0);
    this.errorMessage = "";
    this.personName = this.currentRecord.personName;
    this.taaPin = this.currentRecord.taaPin;
  }

  buildForm() {
    this.documentService.getInternalDocumentType().subscribe(response => {
      this.docTypes = <Array<any>>response;
      const docs: any[] = <Array<any>>response;
      docs.sort((a, b) => {
        return a.DISPLAY_ORDER_NO - b.DISPLAY_ORDER_NO;
      });
      for (let i = 0; i < docs.length; i++) {
        this.apiCount = docs.length - 1;
        setTimeout(
          count => {
            this.documents[count] = {};
            this.documents[count].fileList = [];
            this.documents[count].docType = [];
            Observable.forkJoin(
              this.documentService.getInternalUplodedDocuments(
                this.currentRecord.personId,
                docs[count].DOCUMENT_TYPE_ID
              )
            )
              .finally(() => {
                if (this.apiCount === count) {
                  this.isLoading = false;
                }
              })
              .subscribe(([uploadedFiles]) => {
                const fileList: any = uploadedFiles;
                if (uploadedFiles) {
                  if (fileList.length !== 0) {
                    this.documents[count].fileList = fileList;
                  }
                  if (docs[count]["DOCUMENT_TYPE_DS"]) {
                    docs[count].uploadFlag = false;
                    docs[count].errorMessageFlag = false;
                    docs[count].errorMessage = "";
                    this.documents[count].docType = docs[i];
                  }
                }
              });
          },
          true,
          i
        );
      }
    });
  }

  formatFileSize(bytes, decimalPoint) {
    if (bytes === 0) {
      return "0 Bytes";
    }
    const k = 1000,
      dm = decimalPoint || 2,
      sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"],
      i = Math.floor(Math.log(bytes) / Math.log(k));
    return (
      Math.floor(parseFloat((bytes / Math.pow(k, i)).toFixed(dm))) +
      " " +
      sizes[i]
    );
  }

  fileChange(event) {
    this.fileNm = event.target.files[0];
  }

  save(navigate) {
    let validationFlag = false;
    this.noOfErrors = 0;
    this.documents.forEach(item => {
      if (
        item.fileList &&
        item.docType.DOCUMENT_TYPE_DS !== "Other Documentation"
      ) {
        if (item.fileList[0] && item.fileList[0].FILE_NM === "") {
          this.noOfErrors += 1;
          item.errorMessageFlag = true;
          item.errorMessage = item.docType.DOCUMENT_TYPE_DS + " is required";
          this.deletedDocFlag = false;
          this.successMessage = "";
          validationFlag = true;
          item.displayError = true;
          this.fileExists = true;
        } else {
          item.errorMessageFlag = false;
        }
      } else {
        item.errorMessageFlag = false;
      }
    });
    if (!validationFlag) {
      const updateRequestFromDocument = {
        PERSON_ID: this.currentRecord.personId,
        REQUEST_ID: this.currentRecord.requestId,
        REQUEST_STATE_TX: "6",
        UPDATED_BY_DS: this.currentRecord.userName
      };

      Observable.forkJoin(
        this.documentService.updateInternalRequestForDocument(
          updateRequestFromDocument
        ),
        this.requestSubmitService.getRequestStatusCodeIdByNm(
          this.taaConstants.getINCOMPLETE()
        )
      ).subscribe(
        success => {
          sessionStorage.setItem("docSubmitted", "true");
        },
        err => {
          console.log(err);
        }
      );
    } else {
      this.errorMessageFlag = true;
      return;
    }
    if (navigate === true) {
      this.stepper.goToNextStep();
    }
  }

  uploadFile() {
    this.clickOnce = true;
    if (typeof this.fileNm === "undefined") {
      this.noOfErrors = 1;
      this.errorMessage = "Please select a valid file.";
      this.errorMessageFlag = true;
      this.successMessage = "";
      this.emptyDocErrFlag = false;
      this.deletedDocFlag = false;
      this.clickOnce = false;
      return;
    }
    const fileExtension = require("file-extension");
    const fileExt = fileExtension(this.fileNm.name);
    const fileSize = this.fileNm.size;
    const fileName = this.fileNm.name
      .split(".")
      .slice(0, -1)
      .join("."),
      acceptableFileTypes = ["pdf", "doc", "docx", "txt"];

    if (fileName.length > this.supportedFileLength) {
      this.noOfErrors = 1;
      this.errorMessage =
        "The file name cannot be more than " +
        this.supportedFileLength +
        " characters.";
      this.errorMessageFlag = true;
      this.successMessage = "";
      this.deletedDocFlag = false;
      this.emptyDocErrFlag = false;
      this.clickOnce = false;
      return;
    }

    if (fileSize > this.supportedFileSize) {
      this.noOfErrors = 1;
      this.errorMessage =
        "The upload file size cannot be more than " +
        this.supportedFileSizeMB +
        ". You can try to split the document into multiple parts and upload them separately or check with your IT staff if you need further assistance with decreasing the file size.";
      this.errorMessageFlag = true;
      this.successMessage = "";
      this.deletedDocFlag = false;
      this.emptyDocErrFlag = false;
      this.clickOnce = false;
      return;
    }

    let validExt = false;
    acceptableFileTypes.forEach(function (ext) {
      if (fileExt === ext) {
        validExt = true;
      }
    });

    if (!validExt) {
      this.noOfErrors = 1;
      this.errorMessage =
        "Please select a valid file. File must be in " +
        acceptableFileTypes +
        " format.";
      this.errorMessageFlag = true;
      this.successMessage = "";
      this.emptyDocErrFlag = false;
      this.sameDocErrFlag = false;
      this.deletedDocFlag = false;
      this.clickOnce = false;
      return;
    }

    if (this.fileNm) {
      this.personService
        .uploadFile(
          this.fileNm,
          this.dropDownSelection.DOCUMENT_TYPE_DS,
          this.dropDownSelection.DOCUMENT_TYPE_ID
        )
        .subscribe(result => {
          const res: any = result;
          if (
            res.status === 200 &&
            res.body.status === "Similar document exists"
          ) {
            this.errorMessageFlag = false;
            this.emptyDocErrFlag = false;
            this.successMessage = "";
            this.sameDocErrFlag = true;
            this.deletedDocFlag = false;
            this.clickOnce = false;
          }
          if (
            res.status === 200 &&
            res.body.status === "Uploaded sucessfully"
          ) {
            this.sameDocErrFlag = false;
            this.emptyDocErrFlag = false;
            this.successMessage = "File uploaded successfully";
            this.fileNm.uploadFlag = true;
            this.errorMessageFlag = false;
            this.deletedDocFlag = false;
            this.clickOnce = false;
            this.buildForm();
            return;
          }
        });
    }

    this.ngOnInit();
  }

  downloadFile(event, item: any) {
    this.errorMessageFlag = false;
    this.emptyDocErrFlag = false;
    this.sameDocErrFlag = false;
    this.successMessage = "";
    this.deletedDocFlag = false;
    this.personService.downloadFile(item.FILE_NM);

    event.stopPropagation();
    event.preventDefault();
  }

  deleteFile = (event, item: any) => {
    if (window.confirm("Are you sure you want to delete the document ?")) {
      this.personService.deleteFile(item).subscribe(result => {
        const res: any = result;
        if (res.status === 200 && res.body.status === "Deleted sucessfully") {
          this.errorMessageFlag = false;
          this.emptyDocErrFlag = false;
          this.sameDocErrFlag = false;
          this.successMessage = "";
          this.deletedDocFlag = true;
          this.buildForm();
        }
      });
    }

    event.stopPropagation();
    event.preventDefault();
  }

  goToAccomms() {
    this.stepper.goToPrevStep();
  }
}



// WEBPACK FOOTER //
// ./client/app/internal/accomsupport/accsupportdocumentation/accsupportdocumentation.component.ts